
/**
 * Export `dimensions`.
 */

export const dimensions = {
  kioskNavbarHeight: 104,
  navbarBarHeight: 72,
  navbarHeight: 112,
  navbarHeightMobile: 64,
  preNavbarHeight: 40
};
